export default __webpack_public_path__ + "static/media/section5-pic1-h5.db4695c9.png";